// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"CompanySelect_placeholder__3LxAL","value":"CompanySelect_value__8HZH0"};